import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[orgbrainBlurOnInit]',
  standalone: true,
})
export class BlurOnInitDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private cftf = inject(ConfigurableFocusTrapFactory);

  constructor() {
    console.log('orgbrainBlurOnInit');
  }

  ngAfterViewInit() {
    console.log('orgbrainBlurOnInit ngAfterViewInit');
    const focusTrap = this.cftf.create(this.elementRef.nativeElement);
    // eslint-disable-next-line promise/catch-or-return
    Promise.resolve().then(() => focusTrap.focusLastTabbableElement());
  }
}

// Clean up the focus trap
